import { useAtomValue } from "jotai";
import { useMemo } from "react";

import {
	$document,
	type DocsListRemoteCollabEntry,
	docsListCollabEntry,
	docsListItemRemoteEntry,
} from "../../internal/document-list";

/**
 * Hook to get the collab session info for a document.
 * Returns the branch and sha from the document's collab entry if available.
 *
 * @param documentId - The document ID
 * @returns The collab entry info or undefined if not in collab mode
 */
export const useDocumentCollabInfo = (
	documentId: string | undefined
): DocsListRemoteCollabEntry | undefined => {
	const document = useAtomValue(useMemo(() => $document(documentId), [documentId]));

	return useMemo(() => {
		if (!document) {
			return undefined;
		}
		const remote = docsListItemRemoteEntry(document);
		return docsListCollabEntry(remote);
	}, [document]);
};
